// Shared helpers and constants for the Reaction Studio.

export const fmt = (s) => `${String(Math.floor(s / 60)).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`;

try { ["crs-camera-prefs", "crs-studio-prefs"].forEach((k) => localStorage.removeItem(k)); } catch (e) { /* noop */ }

const TAG_PRESETS_KEY = "crs-tag-presets";
export const loadTagPresets = () => {
  try { return JSON.parse(localStorage.getItem(TAG_PRESETS_KEY)) || []; } catch (e) { return []; }
};
export const saveTagPresets = (tags) => {
  try { localStorage.setItem(TAG_PRESETS_KEY, JSON.stringify(tags)); } catch (e) { /* noop */ }
};

const PRIVACY_KEY = "crs-visibility";
export const loadDefaultPrivacy = () => {
  try { return localStorage.getItem(PRIVACY_KEY) || "public"; } catch (e) { return "public"; }
};
export const saveDefaultPrivacy = (p) => {
  try { localStorage.setItem(PRIVACY_KEY, p); } catch (e) { /* noop */ }
};

// Shared look for the side-panel segmented controls (each button fills its share of the row).
export const segBtn = (active) =>
  `w-full text-xs font-medium py-2 transition-colors ${active ? "bg-zinc-900 text-white" : "bg-white text-zinc-600 hover:bg-zinc-100"}`;
